import * as React from "react";
import WorkspaceFilter from "./WorkspaceFilter";
import Checkbox from "../../../hiberUiKit/src/atoms/Checkbox/Checkbox";

export default abstract class MultiSelectWorkspaceFilter<T> extends WorkspaceFilter<T>{
	getNegationCheckbox() {
		return (
			<div className={"negation-checkbox"}>
				<Checkbox checked={this.state.isNegated}
						  label={"Is not"}
						  onChange={(value) => this.setState({isNegated: value})}/>
			</div>
		)
	}
}